import React, { useMemo, useReducer } from "react";
import useSendEmail from "../../apiHooks/useSendEmail";
import Button from "../../common/button/button.component";
import Input from "../../common/input/input";
import { MergeStateReducer } from "../../common/input/mergeStateReducer";
import SuccessMessage from "../../common/success-message/success-message.component";
import ErrorMessage from "../../common/error-message/error-message.component";
import TextArea from "../../common/text-area/text-area.component";
import { INITIAL_FIELD_STATE } from "../../constants/app.constants";
import { CONTACT_US_INITIAL_STATE } from "../../constants/contact-us.constants";
import { validateEmail, validateEmailBody, validateField } from "../../utils/app.validations";
import PrivateComponent from "../../common/private-component/private-component.component";
import useFetchUserInfo from "../../apiHooks/fetch-user-info/useFetchUserInfo";

const ContactUs = () => {
  const [state, setState] = useReducer(
    MergeStateReducer,
    CONTACT_US_INITIAL_STATE
  );

  const { sendEmail } = useSendEmail();
  const { content: userInfo } = useFetchUserInfo();
  const { emailAddress, subject, message, showSuccessMessage, errorMessage } = state;

  const onSendMail = () => {
    sendEmail({
      subject: subject.value,
      body: message.value,
      emailAddress: emailAddress.value,
    }).then((response) =>  { if(response?.success) {

         setState({ showSuccessMessage: {...showSuccessMessage, value: true }});
         setTimeout( () => setState(CONTACT_US_INITIAL_STATE), 20000);
    
        }
        else{
          setState({errorMessage: {...errorMessage, value: response?.message }, showSuccessMessage: {...showSuccessMessage, value: false}}); 
        }
        
      }).catch( (error) => { setState({...showSuccessMessage,value: false, errors:[error.message]}) });
  };

  const disabledContactUsButton = useMemo(
    () => Object.values(state).some(({ errors }) => errors.length > 0),
    [state]
  );

  return (
    <PrivateComponent>
    <section className="dark:bg-gray-900">
      <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
          Contact Us
        </h2>
        <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
          Got a technical issue? Want to send feedback about us? Need details
          about our Subscription plan? Let us know.
        </p>
        {
          showSuccessMessage.value && <SuccessMessage message=" We have received your inputs. We will respond you in short while" />
        }
        {
          errorMessage.value  && <ErrorMessage errorMessage={errorMessage.value} />
        }
        
        <div className="space-y-8">
          <Input
            placeholder="name@company.com"
            label="Your email address (You will get reply back on this email-id)"
            required
            onChange={(value) =>
              setState({
                emailAddress: { ...emailAddress, value, touched: true, errors: validateEmail(emailAddress.value) },
              })
            }
            onBlur={() =>
              setState({
                emailAddress: {
                  ...emailAddress,
                  errors: validateEmail(emailAddress.value),
                },
              })
            }
            touched={emailAddress.touched}
            errors={emailAddress.errors}
            value={userInfo?.email}
            disabled={true}
          />

          <Input
            placeholder="Let us know how we can help you"
            label="Subject"
            required
            onChange={(value) =>
              setState({ subject: { ...subject, value, touched: true, errors: validateField(subject.value) } })
            }
            onBlur={() =>
              setState({
                subject: {
                  ...subject,
                  errors: validateField(subject.value),
                },
              })
            }
            touched={subject.touched}
            errors={subject.errors}
            value={subject.value}
          />
          <div className="sm:col-span-2">
            <TextArea
              placeholder="Leave a comment"
              label="Message"
              required
              onChange={(value) =>
                setState({ message: { ...message, value, touched: true, errors: validateEmailBody(value) } })
              }
              onBlur={() =>
                setState({
                  message: {
                    ...message,
                    errors: validateEmailBody(message.value),
                  },
                })
              }
              touched={message.touched}
              errors={message.errors}
              value={message.value}
            />
          </div>
          <Button
            displayName="Send Message"
            onClick={onSendMail}
            disabled={disabledContactUsButton}
          />
        </div>
      </div>
    </section>
    </PrivateComponent>
  );
};

export default ContactUs;
